import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'app-no-symptoms-dialog',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, TranslatePipe],
  templateUrl: './no-symptoms-dialog.component.html',
  styleUrls: ['./no-symptoms-dialog.component.scss']
})
export class NoSymptomsDialogComponent {
  constructor(public dialogRef: MatDialogRef<NoSymptomsDialogComponent>) {}
} 
